const UsedAmountProductList = {
  'pages_product_used_amount.title': '상품/회사별 사용료',
  'pages_product_used_amount.customer_title': '상품별 사용료 정보',
  'pages_product_used_amount.no': 'No.',
  'pages_product_used_amount.all': '전체',
  'pages_product_used_amount.month': '월',
  'pages_product_used_amount.category': '카테고리',
  'pages_product_used_amount.product_name': '상품명',
  'pages_product_used_amount.customer_name': '회사명',
  'pages_product_used_amount.customer_dept_name': '사업부명',
  'pages_product_used_amount.amount': '사용료',
  'pages_product_used_amount.currency': '￦',

  'pages_product_used_amount_rank.title_am': '상품별 사용 비용',
  'pages_product_used_amount_rank.title': '상품별 사용 비용',

}

export default UsedAmountProductList



// WEBPACK FOOTER //
// ./src/lang/product/UsedAmountProductList.kr.js